import React, { useEffect } from 'react';
import globals from '../../globals.json';
import AudioPlayer from '../UI/AudioPlayer';

const Route = props => {
    return (
        <div className={`Route circle-${props.data.circlePosition} ${props.data.id}`}>
            {props.complete && <div className={`circle ${props.complete ? 'complete' : ''}`}>
                <div className={`clipboard-image`} />
                <p>{props.data.completedText.toUpperCase()}</p>
            </div>}
            <div className={`route-content`}>
                <h1>{props.data.header.toUpperCase()}</h1>
                <div className={`yellow-underline`} />
                <h2>{props.data.subheader}</h2>
                <p dangerouslySetInnerHTML={{__html:props.data.body}} />
            </div>
            <div className={`arrows-image`} />
            <div className={`global-button continue-button`} onClick={() => props.handleClick(props.data.id)}>{globals.startButtonText}</div>
            <div className={`background`} />
        </div>
    )
}

const RouteSelection = props => {

    useEffect(() => {
        if(props.data.audio) {
            props.audioController.playAudioByName(props.data.audio);
        }

        return () => {
            props.audioController.removeAudio(props.data.audio);
        }
    }, [])

    const selectRoute = (routeId) => {
        props.scoring.initializeTrip(routeId, props.data.tripId);
        props.onComplete();
    }
    return (
        <div className={`RouteSelection ${props.data.class}`}>
            {props.data.audio &&
                <AudioPlayer audioController={props.audioController} audioCollection={props.audioCollection} />}
            {props.data.routes.map(e => {
                console.log("!!!!!!!!!!props.scoring.routesCompleted" , props.scoring.routesCompleted);
                return <Route data={e} handleClick={selectRoute} complete={props.scoring.routesCompleted[e.id]} />
            })}
            <div className={`scrim`} />
            <div className={`trucks-image`} />
            <div className={`preload_Cab`}/>
            <div className={`preload_Crossing`}/>
            <div className={`preload_${props.data.class}`}>
                <div className='crossing-1'></div>
                <div className='crossing-2'></div>
                <div className='crossing-3'></div>
            </div>
        </div>
    )
}

export default RouteSelection